import { getTheme, themed, Box, Text as Tx, } from "@bracket/ui";
import { Badge, } from "@components";
import styled, { css, } from "styled-components";



type NotificationTab = {
  id: string;
  label: string;
  notificationsCount: number;
};



type NotificationTabsProps<TNotificationItems extends ReadonlyArray<NotificationTab>> = {
	items: TNotificationItems;
	activeTab: TNotificationItems[number]["id"];
	onTabChange: (tabId: TNotificationItems[number]["id"]) => void;
};



export const NotificationTabs = <TNotificationItems extends ReadonlyArray<NotificationTab>>({
	items,
	activeTab,
	onTabChange,
}: NotificationTabsProps<TNotificationItems>) => {
	themed();

	return (
		<NotificationTabsContainer>
			{items.map((item) => (
				<NotificationTab key={item.id} $isActive={item.id === activeTab} onClick={() => onTabChange(item.id)}>
					<Tx sm color="heading">{item.label}</Tx>
					<Badge color={item.id === activeTab ? "primary" : "normal"} itemsCount={item.notificationsCount} />
				</NotificationTab>
			))}
		</NotificationTabsContainer>
	);
};



const NotificationTab = styled.button<{ $isActive: boolean }>`
	display: flex;
	gap: 8px;
	padding: 4px 16px;
	background: ${() => getTheme().surface_container_low};
	border-radius: ${() => getTheme().radials.sm};
	cursor: pointer;
	white-space: nowrap;
	border: none;
	${({ $isActive }) => $isActive && `background-color: ${() => getTheme().surface_container_highest};`};
`;

const NotificationTabsContainer = styled(Box)`
	gap: 4px;
	padding: 4px;
	border-radius: 4px;
`;
